import httpStatus from 'http-status';
import oracleApiUrl from '../config/oracle-api-url.js';

const refreshTokens = async () => {
    const refreshToken = sessionStorage.getItem('refreshToken');
    const response = await fetch(`${oracleApiUrl}/auth/refresh-tokens`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken })
    });
    if (response.ok) {
        const { access } = await response.json();
        sessionStorage.setItem('accessToken', access.token);
    } else {
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('refreshToken');
        window.location.href = '/';
    }
};

const callOracleApi = async (
    path,
    method,
    body = {},
    additionalHeaders = {}
) => {
    // eslint-disable-next-line no-param-reassign
    method = method.toLowerCase();
    const url = `${oracleApiUrl}${path}`;

    const makeRequest = async (token) => {
        const options = {
            method: method.toUpperCase(),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
                ...additionalHeaders
            }
        };
        if (method !== 'get' && body) {
            options.body = JSON.stringify(body);
        }
        return fetch(url, options);
    };

    let token = sessionStorage.getItem('accessToken');
    let response = await makeRequest(token);

    if (
        response.status === httpStatus.UNAUTHORIZED &&
        sessionStorage.getItem('refreshToken')
    ) {
        await refreshTokens();
        token = sessionStorage.getItem('accessToken');
        response = await makeRequest(token);
    }

    return response;
};

export default callOracleApi;
